<template>
  <div class="messages-header shadow-sm">
    <b-row class="align-items-center">
      <b-col cols="12" md>
        <b-input
          :value="filter.query"
          autocomplete="off"
          class="form-control-gray"
          placeholder="Search label, people or content"
          @input="onQuery"
        />
      </b-col>
      <b-col cols="auto" lg="2" class="d-none d-lg-block" />
      <b-col cols="auto">
        <b-radio-group :checked="filter.type" @change="onChangeType">
          <b-radio value="received" class="custom-radio-square">Received</b-radio>
          <b-radio value="sent" class="custom-radio-square">Sent</b-radio>
        </b-radio-group>
      </b-col>
      <b-col cols="auto">
        <b-button variant="link" class="btn-link-white text-decoration-none" @click.prevent="onClickDir">
          Date <b-icon-caret-down-fill :rotate="filter.dateDir==='desc' ? 180 : 0" class="color-deeppink" />
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BIconCaretDownFill } from 'bootstrap-vue'

export default {
  name: 'MessagesHeader',

  model: {
    prop: 'filter',
    event: 'change'
  },

  props: {
    filter: {
      type: Object,
      default: () => ({
        query: '',
        type: 'received',
        dateDir: 'asc'
      }),
      validator(value) {
        return ['received', 'sent'].indexOf(value.type) !== -1 &&
          ['asc', 'desc'].indexOf(value.dateDir) !== -1
      }
    }
  },

  methods: {
    onQuery(value) {
      const filter = { ...this.filter, query: value }
      this.$emit('change', { filter, prop: 'query' })
    },

    onClickDir() {
      const filter = {
        ...this.filter,
        dateDir: this.filter.dateDir === 'asc' ? 'desc' : 'asc'
      }
      this.$emit('change', { filter, prop: 'dateDir' })
    },

    onChangeType(value) {
      const filter = { ...this.filter, type: value }
      this.$emit('change', { filter, prop: 'type' })
    }
  },

  components: {
    BIconCaretDownFill
  }
}
</script>
